import React, { Component } from 'react';
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';
import { breakpoints, colors } from '../../style-utilities/variables';
import format from 'date-fns/format';
import placeHolderImage from '../../images/placeholder.png';
import {
  ReviewsStateContext,
  ReviewsStateConsumer
} from '../../context/ReviewsContext';
import Rating from 'react-rating';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-regular-svg-icons';
import { faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons';

const ReviewListStyled = styled.div`
  margin: auto;
  text-align: center;
  width: 100%;
  padding-bottom: 30px;
  margin-top: 70px;
  max-width: ${breakpoints.maxContainer};
  margin: 0 auto;
  .review-bar {

    margin: auto;
    padding: 20px;
    color: white;
    background: ${colors.primary};
    @media (min-width: 500px) {
    text-align: left;

      .write-review {
        float: right;
        margin-top: -8px;
        margin-right: 33px;
      }
    }


  }
  .review-content {
    display: grid;
    grid-template-columns: 30% 70%;
    padding: 40px;
    border-bottom: 1px solid black;
    .profile {
      text-align: left;
      img {
        width: 70px;
        border-radius: 50%;
      }
    }
    .review {
      text-align: left;
    }
  }
`;

class ReviewsList extends Component {
  componentDidMount() {
    this.context.getReviewsForItem(this.props.type, this.props.slug);
  }

  render() {
    return (
      <ReviewsStateConsumer>
        {reviewsStateContext => {
          const { reviews } = reviewsStateContext;
          return (
            <ReviewListStyled>
              {reviews &&
                reviews.length >= 5 &&
                reviews.map((item, index) => {
                  const formattedDate = format(
                    new Date(item.createdAt),
                    'MMMM D, YYYY'
                  );
                  return (
                    <div className="review-content" key={index}>
                      <div className="profile">
                        {!item.hideProfileImage && (
                          <img
                            src={
                              item.userAvatar
                                ? item.userAvatar
                                : placeHolderImage
                            }
                            alt="authorProfile"
                          />
                        )}
                        <h4>{ReactHtmlParser(item.userName)}</h4>
                        <p>{formattedDate}</p>
                      </div>
                      <div className="review">
                        <p>{ReactHtmlParser(item.title)}</p>
                        <p>
                          <Rating
                            emptySymbol={<FontAwesomeIcon icon={faStar} />}
                            fullSymbol={<FontAwesomeIcon icon={faStarSolid} />}
                            initialRating={item.stars}
                            readonly
                            fractions={2}
                          />
                        </p>
                        {ReactHtmlParser(item.text)}
                      </div>
                    </div>
                  );
                })}
            </ReviewListStyled>
          );
        }}
      </ReviewsStateConsumer>
    );
  }
}

ReviewsList.contextType = ReviewsStateContext;

export default ReviewsList;
